import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Ref } from 'vue'

interface Pagination {
  offset: number
  limit: number
}

const defaultPagination = (): Pagination => ({
  offset: 0,
  limit: 20
})

export const usePaginationStore = defineStore(
  'pagination',
  () => {
    const pagination: Ref<Pagination> = ref(defaultPagination())

    // getters
    const getOffset = (): number => pagination.value.offset
    const getLimit = (): number => pagination.value.limit

    // actions
    const updateOffset = (offset: number): void => {
      pagination.value.offset = offset
    }

    const updateLimit = (limit: number): void => {
      pagination.value.limit = limit
    }

    const clearPagination = (): void => {
      pagination.value = defaultPagination()
    }

    return {
      pagination,
      getOffset,
      getLimit,
      updateOffset,
      updateLimit,
      clearPagination
    }
  },
  {
    persist: {
      key: 'pagination'
    }
  }
)
